import { render, staticRenderFns } from "./TransactionsList.vue?vue&type=template&id=5028fb0e&scoped=true&"
import script from "./TransactionsList.vue?vue&type=script&lang=js&"
export * from "./TransactionsList.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsList.vue?vue&type=style&index=0&id=5028fb0e&scoped=true&lang=css&"
import style1 from "./TransactionsList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5028fb0e",
  null
  
)

export default component.exports